export const CONSENT_STORAGE_KEY = "oxya_cookie_preferences";
export const CONSENT_VERSION = 1;
export const CONSENT_MAX_AGE_MS = 183 * 24 * 60 * 60 * 1000;

export const DEFAULT_PREFERENCES = {
  analytics: false,
  externalMedia: false,
};

const hasValidPreferences = (value) =>
  value &&
  value.version === CONSENT_VERSION &&
  typeof value.updatedAt === "string" &&
  typeof value.analytics === "boolean" &&
  typeof value.externalMedia === "boolean";

export const readConsent = (
  storage = window.localStorage,
  currentTime = Date.now()
) => {
  try {
    const savedValue = storage.getItem(CONSENT_STORAGE_KEY);
    if (!savedValue) return null;

    const consent = JSON.parse(savedValue);
    if (!hasValidPreferences(consent)) return null;

    const updatedAt = Date.parse(consent.updatedAt);
    if (!Number.isFinite(updatedAt)) return null;
    if (currentTime - updatedAt > CONSENT_MAX_AGE_MS) return null;

    return consent;
  } catch (error) {
    return null;
  }
};

export const writeConsent = (
  preferences,
  storage = window.localStorage,
  currentTime = Date.now()
) => {
  const consent = {
    version: CONSENT_VERSION,
    updatedAt: new Date(currentTime).toISOString(),
    analytics: Boolean(preferences.analytics),
    externalMedia: Boolean(preferences.externalMedia),
  };

  try {
    storage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent));
  } catch (error) {
    // The in-memory choice still applies if browser storage is unavailable.
  }
  return consent;
};

export const toPrivacyEnhancedYoutubeUrl = (url) =>
  url.replace("www.youtube.com/embed/", "www.youtube-nocookie.com/embed/");

export const clearGoogleAnalyticsCookies = (
  cookieString = document.cookie,
  hostname = window.location.hostname
) => {
  const cookieNames = cookieString
    .split(";")
    .map((cookie) => cookie.split("=")[0].trim())
    .filter((name) => name === "_ga" || name.startsWith("_ga_"));

  const hostnameParts = hostname.split(".");
  const registrableDomain =
    hostnameParts.length > 1 ? hostnameParts.slice(-2).join(".") : hostname;
  const domains = [
    "",
    hostname,
    `.${hostname}`,
    registrableDomain,
    `.${registrableDomain}`,
  ];

  cookieNames.forEach((name) => {
    domains.forEach((domain) => {
      const domainAttribute = domain ? `; domain=${domain}` : "";
      document.cookie = `${name}=; Max-Age=0; path=/${domainAttribute}; SameSite=Lax`;
    });
  });
};
